/* global debounce */

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.form = this.closest('form');

      this.addListeners();
      this.init();
    }

    /* -------------------------
     * LISTENERS
     * ------------------------- */
    addListeners() {
      this.input.addEventListener(
        'input',
        debounce(this.handleInput.bind(this))
      );

      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener(
          'custom-select:change',
          this.handleProductTypeChange.bind(this)
        );
      }

      if (this.form) {
        this.form.addEventListener(
          'submit',
          this.handleSubmit.bind(this)
        );
      }

      this.resetBtn?.addEventListener(
        'click',
        this.handleReset.bind(this)
      );
    }

    /* -------------------------
     * INIT
     * ------------------------- */
    init() {
      this.syncCategoryFromURL();

      if (
        (this.input.dataset.placeholderTwo ||
          this.input.dataset.placeholderThree) &&
        (this.input.dataset.placeholderPromptsMob === 'true' ||
          theme.mediaMatches.md)
      ) {
        this.typeInPlaceholders();
      }
    }

    /* -------------------------
     * INPUT
     * ------------------------- */
    handleInput() {
      this.input.classList.toggle(
        'search__input--dirty',
        this.input.value.length > 0
      );
    }

    /* -------------------------
     * CATEGORY CHANGE
     * ------------------------- */
    handleProductTypeChange(evt) {
      if (!this.productTypeInput) return;

      const value = evt.detail?.selectedValue || '';

      this.productTypeInput.value =
        value === '' || value.toLowerCase().includes('all')
          ? ''
          : value;

      /* 🔥 AUTO-SUBMIT:
         If category selected & keyword empty */
      if (
        this.productTypeInput.value &&
        this.input.value.trim() === ''
      ) {
        this.input.value = '*';
        this.form.submit();
      }
    }

    /* -------------------------
     * SUBMIT (FIX DOUBLE CLICK)
     * ------------------------- */
    handleSubmit(evt) {
      if (
        this.input.value.trim() === '' &&
        this.productTypeInput &&
        this.productTypeInput.value
      ) {
        evt.preventDefault();
        this.input.value = '*';
        this.form.submit();
      }
    }

    /* -------------------------
     * RESET
     * ------------------------- */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
      if (this.productTypeInput) {
        this.productTypeInput.value = '';
      }
    }

    /* -------------------------
     * KEEP CATEGORY AFTER SEARCH
     * ------------------------- */
    syncCategoryFromURL() {
      if (!this.productTypeSelect || !this.productTypeInput) return;

      const params = new URLSearchParams(window.location.search);
      const value = params.get('filter.p.product_type');
      if (!value) return;

      this.productTypeInput.value = value;

      const option = this.productTypeSelect.querySelector(
        `.custom-select__option[data-value="${CSS.escape(value)}"]`
      );
      if (!option) return;

      const label = this.productTypeSelect.querySelector(
        '.custom-select__btn span'
      );
      if (label) label.textContent = option.textContent.trim();

      this.productTypeSelect
        .querySelectorAll('.custom-select__option')
        .forEach((el) => el.removeAttribute('aria-selected'));

      option.setAttribute('aria-selected', 'true');
    }

    /* -------------------------
     * PLACEHOLDER ANIMATION
     * ------------------------- */
    typeInPlaceholders() {
      const typingSpeed = this.input.dataset.typingSpeed || 100;
      const deletingSpeed = this.input.dataset.deletingSpeed || 60;
      const delayAfterDeleting = this.input.dataset.delayAfterDeleting || 500;
      const delayBeforeFirstDelete =
        this.input.dataset.delayBeforeFirstDelete || 2000;
      const delayAfterWordTyped =
        this.input.dataset.delayAfterWordTyped || 2400;

      const placeholders = [];
      if (this.input.placeholder) placeholders.push(this.input.placeholder);
      if (this.input.dataset.placeholderTwo)
        placeholders.push(this.input.dataset.placeholderTwo);
      if (this.input.dataset.placeholderThree)
        placeholders.push(this.input.dataset.placeholderThree);

      const typeText = async (text) => {
        await new Promise((resolve) => {
          let current = this.input.placeholder;
          let next =
            current.length >= 3 && text.startsWith(current)
              ? text.replace(current, '')
              : text;

          const i = setInterval(() => {
            this.input.placeholder += next[0];
            next = next.slice(1);
            if (!next.length) {
              clearInterval(i);
              resolve();
            }
          }, typingSpeed);
        });
      };

      const deleteText = async (next) => {
        await new Promise((resolve) => {
          let i = setInterval(() => {
            this.input.placeholder =
              this.input.placeholder.slice(0, -1);
            if (
              !this.input.placeholder ||
              next.startsWith(this.input.placeholder)
            ) {
              clearInterval(i);
              resolve();
            }
          }, deletingSpeed);
        });
      };

      let index = 0;
      const loop = () => {
        index = (index + 1) % placeholders.length;
        const next = placeholders[index];

        deleteText(next).then(() => {
          setTimeout(() => {
            typeText(next).then(() => {
              setTimeout(loop, delayAfterWordTyped);
            });
          }, delayAfterDeleting);
        });
      };

      setTimeout(loop, delayBeforeFirstDelete);
    }
  }

  customElements.define('search-form', SearchForm);
}
